

export const ObjectSize = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path d="M7.93063 12.6129L7.34999 1M7.93063 12.6129L0.962891 19M7.93063 12.6129H19.5435M7.34999 1L5.60805 2.74194M7.34999 1L9.09192 2.74194M19.5435 12.6129L17.8016 10.871M19.5435 12.6129L17.8016 14.3548M0.962891 16.6774V19M0.962891 19H3.28547"
                stroke="#838280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}